import en from './en.json';
import he from './he.json';

export default { en, he };